import { assertCountry, svLocale, setLocale, type Country } from "./lib/sv_SE";
export * from "./lib/toLocale";

setLocale();

export type Locale = typeof svLocale;

function locale<T extends keyof Locale>(key: T) {
  if (key.trim().length === 0) {
    console.info("Requested translation for empty key");
    return key;
  }
  const result = svLocale[key];

  if (!result) {
    console.error(`Requested locale key '${key}' not found`);
    return key;
  }

  return result;
}

let current = svLocale;

const handler = {
  get(obj: object, prop: keyof Locale) {
    return current[prop];
  }
};

export const set = (val: Locale) => {
  current = val;
};

const localeProxy = new Proxy({}, handler) as Locale;

export { localeProxy as locale, Country, assertCountry };
export default localeProxy;
